import React from "react";

import { useGetIconButtonStyles } from "../../../controls/IconButton";
import { IconButtonProps } from "../../../controls/IconButton/IconButton";
import { Center, styledWithConfig } from "../../../layout";
import Icon from "../../Icon";
import { AvatarSize, avatarSizeToStylesMap } from "../consts";
import SecondaryCircle from "./SecondaryCircle";

const ButtonComponent = styledWithConfig("button");

type ActionButtonProps = Omit<IconButtonProps, "blend" | "size"> & {
  avatarSize: AvatarSize;
};

const ActionButton = React.forwardRef<any, ActionButtonProps>(
  (
    {
      iconName,
      onClick,
      accessibilityLabel,
      disabled = false,
      tone = "primary",
      avatarSize
    },
    ref
  ) => {
    const styleProps = useGetIconButtonStyles({
      tone,
      disabled,
      blend: false
    });

    const {
      secondaryCircleSize,
      secondaryCirclePadding: padding
    } = avatarSizeToStylesMap[avatarSize];

    return (
      <SecondaryCircle size={secondaryCircleSize}>
        <ButtonComponent
          padding={padding}
          onClick={onClick}
          aria-label={accessibilityLabel ?? undefined}
          disabled={disabled}
          ref={ref}
          {...styleProps}
          width="100%"
          height="100%"
        >
          <Center>
            <Icon accessibilityLabel={null} iconName={iconName} size="fill" />
          </Center>
        </ButtonComponent>
      </SecondaryCircle>
    );
  }
);

export default ActionButton;
